import { getEnvVariableValue } from '@experiences/util';
import { useMemo } from 'react';
import {
    matchPath,
    useLocation,
} from 'react-router';

import {
    useIsGovernanceRouteMatched,
    useIsSettingsRouteMatched,
} from '../../util/RouteUtil';
import * as RouteNames from '../constants/RouteNames';
import useIsProfileRoute from './useIsProfileRoute';
import useIsTestCloud from './useIsTestCloud';

const useProductName = () => {

    const isProfileRoute = useIsProfileRoute();
    const isSettingsRoute = useIsSettingsRouteMatched();
    const isGovernanceRoute = useIsGovernanceRouteMatched();
    const { pathname } = useLocation();
    const isTenantCreateRoute = matchPath({ path: RouteNames.TenantCreate }, pathname);

    const isTestCloudUser = useIsTestCloud();

    const showTrademark = useMemo(
        () => !isProfileRoute && !isSettingsRoute && !isTenantCreateRoute,
        [ isProfileRoute, isSettingsRoute, isTenantCreateRoute ],
    );

    const productName = useMemo<string>(() => {
        if (isProfileRoute) {
            return '';
        }

        if (isGovernanceRoute) {
            return 'Governance';
        }

        if (isSettingsRoute || isTenantCreateRoute) {
            return 'Administration';
        }

        if (isTestCloudUser) {
            return 'Test Cloud';
        }

        return getEnvVariableValue('PRODUCT_NAME');
    }, [ isProfileRoute, isGovernanceRoute, isSettingsRoute, isTenantCreateRoute, isTestCloudUser ]);

    return {
        productName,
        showTrademark,
    };
};

export default useProductName;
